// @ts-nocheck
import { notesStyles, OrderDetailsNotesStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes";
import { infoProps } from "@store/Themes/common/props/info";

Object.assign<OrderDetailsNotesStyles>(notesStyles, {
    titleText: infoProps.label,
    notesText: infoProps.value,
});
